import * as React from 'react';
import {IApiQueryData, IProductReviewItem} from 'PyzShopUi/scripts/product-review/interfaces';
import ProductReviewItem
    from 'PyzShopUi/scripts/product-review/components/product-review-list/product-review-item/ProductReviewItem';
import LoadMore from 'PyzShopUi/scripts/product-review/components/product-review-list/common/LoadMore';
import ProductReviewNoItem
    from 'PyzShopUi/scripts/product-review/components/product-review-list/common/ProductReviewNoItem';
import Header from 'PyzShopUi/scripts/product-review/components/product-review-list/header/Header';
import {ISelectFilter, ISelectFilterOption, ISort} from 'PyzShopUi/scripts/shop-ui/components/search-page/interfaces';
import Loading from 'PyzShopUi/scripts/react/common/components/Loading';
import {DEFAULT_PARAM_LANGUAGE, PARAM_LANGUAGE, PARAM_RATING} from 'PyzShopUi/scripts/product-review/constants';
import SelectFilterUtils from 'PyzShopUi/scripts/utils/selectFilterUtils';
import ProductReviewNoItemWithFilter
    from 'PyzShopUi/scripts/product-review/components/product-review-list/common/ProductReviewNoItemWithFilter';

interface IProductReviewListProps {
    productReviews: IProductReviewItem[];
    sort: ISort;
    currentPage: number,
    maxPage: number,
    isProgressing: boolean
    dispatch: React.Dispatch<any>;
    filters?: ISelectFilter[];
    apiQueries?: IApiQueryData;
}

const ProductReviewList: React.FunctionComponent<IProductReviewListProps> = props => {
    const {
        currentPage,
        maxPage,
        isProgressing,
        productReviews,
        sort,
        dispatch,
        filters,
        apiQueries
    } = props;

    if (isProgressing && !productReviews.length) {
        return (
            <div className="cell product-review-detail">
                <Loading/>
            </div>
        );
    }

    const itemLanguageOptions: ISelectFilterOption[] = SelectFilterUtils.getOptionsByName(filters, PARAM_LANGUAGE, []);
    const currentItemsLanguage: string = SelectFilterUtils.getCurrentOption(itemLanguageOptions, DEFAULT_PARAM_LANGUAGE);

    const displayResultHeader = () => {
        return (
            <Header
                itemLanguageOptions={itemLanguageOptions}
                currentItemsLanguage={currentItemsLanguage}
                sortParamNames={sort.sortParamNames}
                currentSortParam={sort.currentSortParam}
                dispatch={dispatch}
            />
        );
    };

    if (!productReviews.length) {
        if (apiQueries && SelectFilterUtils.isMultipleFilterSelect(apiQueries, [PARAM_RATING, PARAM_LANGUAGE])) {
            return (
                <div className="cell product-review-detail">
                    <div className="result-header grid-padding-y">
                        {displayResultHeader()}
                    </div>
                    <ProductReviewNoItemWithFilter/>
                </div>
            )
        }
        return <ProductReviewNoItem/>;
    }

    const displayProductReviewItems = () => productReviews.map((productReview: IProductReviewItem) => (
        <ProductReviewItem
            productReviewItem={productReview}
            key={productReview.idProductReview}
        />
    ));

    const displayLoadMore = () => {
        if (currentPage < maxPage) {
            return (
                <LoadMore
                    currentPage={currentPage}
                    maxPage={maxPage}
                    dispatch={dispatch}
                    isProgressing={isProgressing}
                />
            );
        }

        return null;
    };

    const displayLoading = () => {
        return isProgressing ? (<Loading/>) : null;
    };

    return (
        <div className="cell product-review-detail">
            <div className="result-header grid-padding-y">
                {displayResultHeader()}
            </div>
            {displayProductReviewItems()}
            {displayLoading()}
            {displayLoadMore()}
        </div>
    );
};

export default ProductReviewList;
